import {
  OPEN_SIGNUP_MODAL,
  CLOSE_SIGNUP_MODAL,
  OPEN_COMPANY_SIGNUP_MODAL,
  OPEN_INFLUENCER_SIGNUP_MODAL
} from '../constants';

const initState = {
  signupModalIsOpen: false
};

const signupModalReducer = (state = initState, action) => {
  switch (action.type) {
    case OPEN_SIGNUP_MODAL:
      return {
        ...state,
        signupModalIsOpen: true
      };
    case OPEN_COMPANY_SIGNUP_MODAL:
      return {
        ...state,
        signupModalIsOpen: true,
        companySignup: true
      };
    case OPEN_INFLUENCER_SIGNUP_MODAL:
      return {
        ...state,
        signupModalIsOpen: true,
        influencerSignup: true
      };
    case CLOSE_SIGNUP_MODAL:
      return {
        ...state,
        signupModalIsOpen: false,
        companySignup: false,
        influencerSignup: false
      };

    default:
      return state;
  }
};

export default signupModalReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/signupModalReducer.js